var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Payment Confirming...")]),(_vm.threeSecureRedirectMethod === 'POST')?_c('form',{ref:"redirectForm",attrs:{"action":_vm.threeSecureRedirectUrl,"method":"POST"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }